import { AutogenModelEdiFunctionalGrp, AutogenRowEdiFunctionalGrp } from "./autogen/AutogenModelEdiFunctionalGrp";

export class ModelEdiFunctionalGrp extends AutogenModelEdiFunctionalGrp<RowEdiFunctionalGrp> {
	constructor() {
		super(RowEdiFunctionalGrp);
	}
}

export class RowEdiFunctionalGrp extends AutogenRowEdiFunctionalGrp {
}